import { useAuth } from "../context/auth";
import { TopBar } from "../components/topBar";
import { LoginModal } from "../components/loginModal";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app")({
  component: () => {
    const { isAuthenticated } = useAuth();

    return (
      <>
        <TopBar />
        {isAuthenticated && <Outlet />}
        <LoginModal />
      </>
    );
  }
});
